import * as React from "react"
import { SaleAdvert, SaleAdvertTranslation } from "../../../types/types";
import ReadMore from "../../shared/advert/ReadMore";
import SimpleFormat from "../../../utils/SimpleFormat";

type Props = {
  advert: SaleAdvert
  translation: SaleAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  !!props.translation && props.translation.buildingState ?
    <>
      <div className="content-part">
        <div className="description">
          <ReadMore
            height={180}
          >
            <SimpleFormat
              text={props.translation.buildingState}
            />
          </ReadMore>
        </div>
      </div>
      <hr />
    </>
  : <></>
)
